import * as React from "react";

export default function useForceRerenderOnMount(config?: { skip?: boolean }) {
  const [hasMounted, setHasMounted] = React.useState(false);
  // eslint-disable-next-line replo/no-use-effect -- Legacy effect - may or may not be necessary
  React.useEffect(() => {
    if (config?.skip) {
      return;
    }
    setHasMounted(true);
  }, [config?.skip]);
  return hasMounted;
}
